import React from "react";

import "./electricity.css";

import Widget from "app/components/widget/Widget";
import PageWrapper from "app/components/page-wrapper/PageWrapper";
import ElectricityBillers from "app/components/electricity-biller/ElectricityBillers";
import SubscriptionDetails from "app/components/subscription-details/SubscriptionDetails";
import SubscriptionMembership from "app/components/subscription-membership/SubscriptionMembership";
import SubscriptionSummary from "app/components/subscription-summary/SubscriptionSummary";

function Electricity() {
  const [step, setStep] = React.useState(1);

  const changeStep = (val) => {
    setStep(val);
  };

  return (
    <PageWrapper title="Subscriptions">
      <div className="row  my-4 pay-bills">
        <div className="col-md-3 col-12">
          <Widget step={step} changeStep={changeStep}></Widget>
        </div>
        <div className="col-md-8 col-12">
          <div className="position_relative">
            {step === 1 && (
              <div className="widget-insurance">
                <ElectricityBillers changeStep={changeStep} />
              </div>
            )}
            {step === 2 && (
              <div className="widget-listing">
                <SubscriptionDetails changeStep={changeStep} />
              </div>
            )}
            <div className="widget-provider">
              {step === 3 && <SubscriptionMembership changeStep={changeStep} />}
              {step === 4 && <SubscriptionSummary changeStep={changeStep} />}
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}

export default Electricity;
